
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

import moment from "moment"

import api from "@/services/api"
import eventApi from "@/services/api.event"

import KeyMedia from "./KeyMedia.vue"

import { CaseEvent, CaseEvents, KeyMedia as KeyMediaEntry } from "@/types/originatingEvents"
import { CaseDetails } from "@/types"
import { KeyEntry } from "@/types/originatingEvents/keyEntry"

const caseStore = namespace("cases")

@Component({
	components: {
		"key-media": KeyMedia
	}
})
export default class KeyEntries extends Vue {
	@Prop({ type: Boolean, default: false })
	public displayAsList!: boolean;

	@Prop()
	public currentCase!: CaseDetails;

	@Prop()
	canEditCurrentCase!: boolean;

	@Prop({ default: () => null })
	public caseEvents!: CaseEvents | null;

	@caseStore.Mutation
	public setShowCCEvent!: (ccEvent: CaseEvent) => void;

	public asLocal (dateString: string) {
		return dateString ? moment(dateString).format("l LTS") : ""
	}

	private removeKey (event: CaseEvent, eventRecord: KeyEntry) {
		eventApi.eventRecordMarkKey(this.currentCase!.id!, event.id, eventRecord.eventRecordId, false)
	}
}

